import './hero.scss';
import './hero.html.twig';
import objectFitImages from 'object-fit-images';

export default function () {
  const hero = document.querySelector('.hero');

  if (!hero) {
    return;
  }

  function removeLoadingClass() {
    document.body.classList.remove('js-loading');
  }

  document.body.classList.add('js-loading');
  window.addEventListener('load', removeLoadingClass);

  const image = hero.querySelector('picture img');
  objectFitImages(image);

  // Add play/pause options to video
  const video = document.querySelector('.hero__video > video');
  if (video) {
    const play = document.querySelector('.hero__video__play');
    play.addEventListener('click', () => {
      play.classList.toggle('hero__video__play--paused');
      video.paused ? (play.ariaLabel = 'pause') : (play.ariaLabel = 'play');
      video.paused ? video.play() : video.pause();
    });
  }
}
